import { FC, useEffect } from 'react';
import { useCurrentBreakpoint } from '../hooks/useCurrentBreakpointHook';

interface BreakpointProviderProps {
  children: React.ReactNode;
}

export const BreakpointProvider: FC<BreakpointProviderProps> = ({ children }) => {
  const currentBreakpoint = useCurrentBreakpoint();

  useEffect(() => {
    document.body.setAttribute('data-breakpoint', currentBreakpoint);
  }, [currentBreakpoint]);

  return <>{children}</>;
};

